import React from 'react'

import './index.scss'

interface IProps {
  body: JSX.Element
  show: boolean
  zIndex?: number
  header?: JSX.Element
  type?: 'confirm' | 'regular'
  onHide?: () => any
}

const Modal: React.FC<IProps> = (props) => {
  const handleClose = (e: React.MouseEvent<HTMLDivElement>) => {
    if (
      (e.nativeEvent.target as HTMLDivElement).classList.contains('overlay') &&
      props.onHide
    ) {
      props.onHide()
    }
  }

  if (!props.show) {
    return <span />
  }

  if (props.type && props.type === 'confirm') {
    return (
      <div
        className='overlay confirm-overlay'
        onClick={handleClose}
      >
        <div id='modal-confirm-body'>
          {props.body}
        </div>
      </div>
    )
  }

  return (
    <div
      data-testid='modal'
      className='overlay regular-overlay'
      onClick={handleClose}
    >
      <div className='modal-inner'>
        <div id='modal-header'>
          {props.header}
        </div>
        <div id='modal-body'>
          {props.body}
        </div>
      </div>
    </div>
  )
}

export {
  Modal
}
